import { atomWithStorage } from '@teetsh/app/src/utils/atomWithStorage';
import { CopyMethod } from './copyMethod';

export const preferedCopyMethodAtom = atomWithStorage<CopyMethod>(
  'preferedCopyMethod',
  'copyEdt',
);
